// extracted by mini-css-extract-plugin
export default {"root":"CreditOperations_root__ILJGn"};